// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adding-single-product {
  display: flex;
}
.adding-single-product .modals-wrap {
  width: 100%;
}
.adding-single-product .modal-main {
  padding-inline: 0;
  padding-block: 18px 0px;
  top: auto;
}
.adding-single-product .modal-main:has(.adding-single-product-list) {
  max-width: 680px;
  min-width: 680px;
}
.adding-single-product .modal-close-btn {
  color: #333333;
  height: 21px;
  width: 23px;
  top: 17px;
}
.adding-single-product .modal-header {
  display: block;
  margin-bottom: 0px;
  margin-inline: -3px;
  padding-inline: 37px;
  border-bottom: 1px solid #D2D2D2;
  padding-bottom: 17px;
  text-align: center;
  font-family: var(--font-family);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.18px;
}
.adding-single-product .modal-content {
  padding-inline: 37px;
  margin-inline: -3px;
  padding-block: 20px;
  font-family: var(--font-family);
}
.adding-single-product .radio-option-product-img-title-wrap {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
  margin-left: 20px;
}
.adding-single-product .radio-option-product-img {
  max-width: 81px;
  max-height: 81px;
  height: 100%;
  width: 100%;
  padding: 18px 10px;
  border-radius: 6px;
  background: #F8F8F8;
  border: 1px solid #F8F8F8;
}
.adding-single-product .radio-option-product-title {
  font-family: var(--font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  color: #333;
  max-width: 182px;
}
.adding-single-product .modal-content {
  overflow-y: auto;
  max-height: 66vh;
}
.adding-single-product .product_status {
  margin-bottom: 10px;
}
.adding-single-product .modal-content::-webkit-scrollbar-thumb {
  background-color: #ACACAC;
  width: 6px;
}
.adding-single-product .modal-content::-webkit-scrollbar {
  width: 6px;
  background: #EFEFEF;
  border-radius: 10px;
}
.adding-single-product .modal-button-wrap button {
  width: 100%;
  max-width: 100%;
  border-radius: 4px;
  background: #6ECB44;
  color: #FFF;
  text-align: center;
  font-family: var(--font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.7px;
  text-transform: uppercase;
  margin-bottom: -3px;
  padding-block: 12px;
}
.adding-single-product .modal-button-wrap {
  display: flex;
  justify-content: center;
  border-top: 1px solid #D2D2D2;
  margin-inline: -3px;
}
.adding-single-product input::-webkit-search-cancel-button {
  display: none;
}
.adding-single-product .change-erp-product-price-popup span.mat-prefix,
.adding-single-product .non-erp-newly-mapped span.mat-prefix {
  width: 38px;
  height: 40px;
  display: flex;
  align-items: center;
  border-radius: 5px 0px 0px 5px;
  border-right: 1px solid #D2D2D2;
  background: #EDEDED;
  justify-content: center;
  margin-right: 4px;
}
.adding-single-product .change-erp-product-price-popup span.mat-prefix {
  border-right: none;
  margin-right: 0px;
  width: auto;
  padding-left: 10px;
  background-color: inherit;
}
.adding-single-product .adding-single-product-list .modal-content-header {
  font-family: var(--font-family);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 27.5px;
  text-align: center;
  max-width: 380px;
  margin: auto;
  margin-bottom: 20px;
}
.adding-single-product .adding-single-product-list .modal-content-header:has(+ .custom-form-error) {
  margin-bottom: 0;
}
.adding-single-product .adding-single-product-list .custom-form-error {
  font-family: var(--font-family);
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  padding-block: 0;
  color: #dc3545;
  text-align: center;
  margin-bottom: 20px;
}
.adding-single-product .adding-single-product-list .load-more-btn {
  display: flex;
  margin-block: 10px;
  justify-content: center;
}
.adding-single-product .adding-single-product-list .load-more-btn button {
  border-radius: 5px;
  border: 1px solid #6ECB44;
  background: #FFF;
  color: #6ECB44;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  max-width: 160px;
  margin: auto;
}
.adding-single-product .adding-single-product-list .mat-mdc-radio-button .mdc-form-field {
  width: 100%;
}
.adding-single-product .adding-single-product-list .radio-option-title-input-grp {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}

@media screen and (max-width: 767px) {
  .adding-single-product .adding-single-product-list .radio-option-title-input-grp {
    flex-direction: column;
    align-items: start;
    gap: 15px;
    max-width: 182px;
  }
  .adding-single-product .modal-main:has(.adding-single-product-list) {
    max-width: 480px;
    min-width: 480px;
  }
  .adding-single-product .radio-option-product-img-title-wrap {
    justify-content: space-between;
  }
  .adding-single-product .modal-content {
    padding-inline: 25px;
  }
}
@media screen and (max-width: 592px) {
  .adding-single-product .modal-main:has(.adding-single-product-list) {
    max-width: 400px;
    min-width: 400px;
  }
}
@media screen and (max-width: 492px) {
  .adding-single-product .modal-main {
    max-width: 330px;
  }
  .adding-single-product .modal-main:has(.adding-single-product-list) {
    max-width: 330px;
    min-width: 330px;
  }
  .adding-single-product .change-erp-product-price-popup .modal-content-main.data_filter {
    flex-direction: column;
    gap: 15px;
  }
  .adding-single-product .modal-content {
    padding-inline: 15px;
  }
  .adding-single-product .radio-option-product-img-title-wrap {
    gap: 15px;
    margin-left: 10px;
  }
  .adding-single-product .modal-header {
    font-size: 15px;
  }
  .adding-single-product .map-erp-product-popup .modal-content-header,
  .adding-single-product .adding-single-product-list .modal-content-header {
    font-size: 14px;
    line-height: 20px;
  }
}
.product_status {
  text-align: center;
  font-size: 16px;
  opacity: 0.5;
}

.adding-single-product-list .modal-content-header {
  color: #000;
  font-family: var(--font-family);
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 27.5px;
  text-align: center;
  max-width: 380px;
  margin: auto;
  margin-bottom: 20px;
}
.adding-single-product-list .mat-mdc-radio-button .mdc-form-field {
  width: 100%;
}
.adding-single-product-list .radio-option-title-input-grp {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/products/adding-single-product/adding-single-product.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;AAAI;EACI,WAAA;AAER;AAEI;EACI,iBAAA;EAEA,uBAAA;EACA,SAAA;AADR;AAEQ;EACI,gBAAA;EACA,gBAAA;AAAZ;AAII;EACI,cAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;AAFR;AAII;EACI,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;EACA,oBAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AAFR;AAII;EACI,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,+BAAA;AAFR;AAMI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;AAJR;AAMI;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AAJR;AAMI;EACI,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AAJR;AAOI;EACI,gBAAA;EACA,gBAAA;AALR;AAUI;EACI,mBAAA;AARR;AAUI;EAEI,yBAAA;EACA,UAAA;AATR;AAWI;EACI,UAAA;EACA,mBAAA;EACA,mBAAA;AATR;AAYI;EACI,WAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AAVR;AAYI;EACI,aAAA;EACA,uBAAA;EACA,6BAAA;EACA,mBAAA;AAVR;AAYI;EACI,aAAA;AAVR;AAYI;;EAEQ,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAVZ;AAYI;EACI,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;AAVR;AAcQ;EACI,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AAZZ;AAcQ;EACI,gBAAA;AAZZ;AAcQ;EACI,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAZZ;AAcQ;EACI,aAAA;EACA,kBAAA;EACA,uBAAA;AAZZ;AAcQ;EACI,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AAZZ;AAcQ;EACI,WAAA;AAZZ;AAcQ;EACI,aAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;AAZZ;;AAmBA;EAIY;IACI,sBAAA;IACA,kBAAA;IACA,SAAA;IACA,gBAAA;EAnBd;EAuBU;IACI,gBAAA;IACA,gBAAA;EArBd;EAwBM;IACI,8BAAA;EAtBV;EAwBM;IACI,oBAAA;EAtBV;AACF;AA2BA;EAKY;IACI,gBAAA;IACA,gBAAA;EA7Bd;AACF;AAiCA;EAEQ;IACI,gBAAA;EAhCV;EAiCU;IACI,gBAAA;IACA,gBAAA;EA/Bd;EAqCU;IACI,sBAAA;IACA,SAAA;EAnCd;EAsCM;IACI,oBAAA;EApCV;EAsCM;IACM,SAAA;IACA,iBAAA;EApCZ;EAsCM;IACI,eAAA;EApCV;EAyCU;;IACI,eAAA;IACA,iBAAA;EAtCd;AACF;AA+CA;EACI,kBAAA;EACA,eAAA;EACA,YAAA;AA7CJ;;AAiDI;EACI,WAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AA9CR;AAgDI;EACI,WAAA;AA9CR;AAgDI;EACI,aAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;AA9CR","sourcesContent":[".adding-single-product{\n    display: flex;\n    .modals-wrap{\n        width: 100%;\n        \n    }\n    \n    .modal-main{\n        padding-inline: 0;\n        \n        padding-block: 18px 0px;\n        top: auto;\n        &:has(.adding-single-product-list){\n            max-width: 680px;\n            min-width: 680px;\n        }\n       \n    }\n    .modal-close-btn {\n        color: #333333;\n        height: 21px;\n        width: 23px;\n        top: 17px;\n    }\n    .modal-header {\n        display: block;\n        margin-bottom: 0px;\n        margin-inline: -3px;\n        padding-inline: 37px;\n        border-bottom: 1px solid #D2D2D2;\n        padding-bottom: 17px;\n        text-align: center;\n        font-family:  var(--font-family);\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 20px;\n        letter-spacing: 0.18px;\n    }\n    .modal-content {\n        padding-inline: 37px;\n        margin-inline: -3px;\n        padding-block: 20px;\n        font-family:  var(--font-family);\n       \n    }\n  \n    .radio-option-product-img-title-wrap {\n        display: flex;\n        align-items: center;\n        gap: 20px;\n        margin-bottom: 20px;\n        margin-left: 20px;\n    }\n    .radio-option-product-img {\n        max-width: 81px;\n        max-height: 81px;\n        height: 100%;\n        width: 100%;\n        padding: 18px 10px;\n        border-radius: 6px;\n        background: #F8F8F8;\n        border: 1px solid #F8F8F8;\n    }\n    .radio-option-product-title {\n        font-family:  var(--font-family);\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: normal;\n        color: #333;\n        max-width: 182px;\n    }\n\n    .modal-content {\n        overflow-y: auto;\n        max-height: 66vh;\n        // min-height: 66vh;\n\n    }\n    \n    .product_status {\n        margin-bottom: 10px;\n    }\n    .modal-content::-webkit-scrollbar-thumb\n    {\n        background-color:#ACACAC;\n        width: 6px;\n    }\n    .modal-content::-webkit-scrollbar {\n        width: 6px;\n        background: #EFEFEF;\n        border-radius: 10px;\n    }\n  \n    .modal-button-wrap button {\n        width: 100%;\n        max-width: 100%;\n        border-radius: 4px;\n        background: #6ECB44;\n        color: #FFF;\n        text-align: center;\n        font-family:  var(--font-family);\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: normal;\n        letter-spacing: 0.7px;\n        text-transform: uppercase;\n        margin-bottom: -3px;\n        padding-block: 12px;\n    }\n    .modal-button-wrap {\n        display: flex;\n        justify-content: center;\n        border-top: 1px solid #D2D2D2;\n        margin-inline: -3px;\n    }\n    input::-webkit-search-cancel-button{\n        display: none;\n    }\n    .change-erp-product-price-popup  span.mat-prefix,\n    .non-erp-newly-mapped span.mat-prefix {\n            width: 38px;\n            height: 40px;\n            display: flex;\n            align-items: center;\n            border-radius: 5px 0px 0px 5px;\n            border-right: 1px solid #D2D2D2;\n            background: #EDEDED;\n            justify-content: center;\n            margin-right: 4px;\n    }\n    .change-erp-product-price-popup span.mat-prefix{\n        border-right:none;\n        margin-right: 0px;\n        width: auto;\n        padding-left: 10px;\n        background-color: inherit;\n    }\n    \n    .adding-single-product-list{\n        .modal-content-header {\n            font-family:  var(--font-family);\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 27.5px;\n            text-align: center;\n            max-width: 380px;\n            margin: auto;\n            margin-bottom: 20px;\n        }\n        .modal-content-header:has( + .custom-form-error){\n            margin-bottom: 0;\n        }\n        .custom-form-error {\n            font-family:  var(--font-family);\n            font-size: 10px;\n            font-style: normal;\n            font-weight: 500;\n            padding-block: 0;\n            color: #dc3545;\n            text-align: center;\n            margin-bottom: 20px;\n        }\n        .load-more-btn {\n            display: flex;\n            margin-block: 10px;\n            justify-content: center;\n        }\n        .load-more-btn button {\n            border-radius: 5px;\n            border: 1px solid #6ECB44;\n            background: #FFF;\n            color: #6ECB44;\n            text-align: center;\n            font-size: 14px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: 20px;\n            max-width: 160px;\n            margin: auto;\n        }\n        .mat-mdc-radio-button .mdc-form-field{\n            width: 100%;\n        }\n        .radio-option-title-input-grp{\n            display: flex;\n            justify-content: space-between;\n            width: 100%;\n            align-items: center;\n        }\n    }\n \n    \n}\n\n@media screen and (max-width:767px) {\n    .adding-single-product{\n        .adding-single-product-list\n        {   \n            .radio-option-title-input-grp{\n                flex-direction: column;\n                align-items: start;\n                gap: 15px;\n                max-width: 182px;\n            }\n        }\n        .modal-main{\n            &:has(.adding-single-product-list){\n                max-width: 480px;\n                min-width: 480px;\n            }\n        }\n        .radio-option-product-img-title-wrap{\n            justify-content: space-between;\n        }\n        .modal-content{\n            padding-inline: 25px;\n        }\n    }\n   \n}\n\n@media screen and (max-width:592px) {\n    .adding-single-product{\n       \n        .modal-main{\n         \n            &:has(.adding-single-product-list){\n                max-width: 400px;\n                min-width: 400px;\n            }\n        }\n    }\n}\n@media screen and (max-width:492px) {\n    .adding-single-product{\n        .modal-main{\n            max-width: 330px;\n            &:has(.adding-single-product-list){\n                max-width: 330px;\n                min-width: 330px;\n            }\n           \n        }\n        .change-erp-product-price-popup\n          {\n            .modal-content-main.data_filter {\n                flex-direction: column;\n                gap: 15px;\n            }\n         }\n        .modal-content{\n            padding-inline: 15px;\n        }\n        .radio-option-product-img-title-wrap{\n              gap: 15px;\n              margin-left: 10px;\n        }\n        .modal-header{\n            font-size: 15px;\n        }\n  \n        .map-erp-product-popup,\n        .adding-single-product-list{\n            .modal-content-header{\n                font-size: 14px;\n                line-height: 20px;\n            \n            }\n        }\n    }\n\n\n}\n\n\n.product_status{\n    text-align: center;\n    font-size: 16px;\n    opacity: .5;\n}\n\n.adding-single-product-list{\n    .modal-content-header {\n        color: #000;\n        font-family:  var(--font-family);\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 27.5px;\n        text-align: center;\n        max-width: 380px;\n        margin: auto;\n        margin-bottom: 20px;\n    }\n    .mat-mdc-radio-button .mdc-form-field{\n        width: 100%;\n    }\n    .radio-option-title-input-grp{\n        display: flex;\n        justify-content: space-between;\n        width: 100%;\n        align-items: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
